const shouchao = {
  fontFamilyNumber: 'THS Money font',
  gridStyle: {
    left: 10,
    right: 10,
    top: 8
  },
  yAxis: {
    axisLabel: {
      width: undefined
    }
  },
  color: {
    axisLabel: 'rgba(0, 0, 0, 0.6)',
    legendLabel: 'rgba(0, 0, 0, 0.6)',
    tooltipTimeText: 'rgba(255, 255, 255, 0.6)',
    tooltipLabel: 'rgba(255, 255, 255, 0.84)',
    tooltipValue: 'rgba(255, 255, 255, 0.84)',
    priceUp: 'rgba(255, 36, 54)',
    priceDown: 'rgba(7, 171, 75)'
  },
  tooltip: {
    backgroundColor: 'rgba(59, 59, 59, 0.6)',
    radius: 4,
    padding: [8, 8, 8, 8],
    margin: 4
  },
  lineStyle: {
    splitLineColor: '#rgba(0, 0, 0, 0.08)',
    splitLineWidth: 0.5,
    zeroAxesColor: '#858585',
    zeroAxesWidth: 1,
    axisPointerLineColor: 'rgba(59, 59, 59, 1)',
    axisPointerLineWidth: 1
  },
  fontSizeList: {
    axisName: 10,
    axisLabel: 10,
    legendLabel: 12,
    tooltipLabel: 12,
    axisPointerLabel: 10,
    seriesLabel: 10,
    titleLabel: 18,
    tooltipTimeText: 10,
    tooltipValue: 12
  },
  fontWeightList: {
    bold: 'bold',
    normal: 'normal',
    bolder: 'bolder',
    lighter: 'lighter',
    axisLabel: 500,
    axisName: 400,
    barLabel: 500,
    tooltipTimeText: 500,
    tooltipLabel: 400,
    tooltipValue: 500
  },
  fontFamilyList: {
    thsFontFamilyMedium: 'THSJinRongTi-Medium',
    thsFontFamily: 'PingFangSC-Regular',
    pingFangSC: 'PingFangSC-Regular',
    barLabel: 'THSJinRongTi-Medium',
    axisLabel: 'THSJinRongTi-Medium',
    axisPointerLabel: 'THSJinRongTi-Medium',
    axisName: 'PingFangSC-Regular',
    seriesLabel: 'PingFangSC-Regular',
    tooltipTimeText: 'THSJinRongTi-Regular',
    tooltipValue: 'THSJinRongTi-Medium'
  },
  lineHeightList: {
    tooltipLabel: 16
  },
  /** 柱状图规范 */
  bar: {
    seriesColor: ['#52BBFF', '#3366FF', '#FF9500', '#CC41D9', '#14CCBD', '#83D537', '#858585'],
    /** 不同系列柱子间距和柱宽比例为 2:1 */
    barGap: '50%',
    /** 单柱情况下，相邻两组间距和柱宽比例为 2:1 */
    barCategoryGap: '33%',
    /** 柱子圆角 */
    radius: [],
    /**
     * 最大柱宽
     *
     * ! 用 barMaxWidth 而不用 barWidth 是因为数据密集时需要自适应缩放
     */
    barMaxWidth: 16,
    /** 最小柱高 */
    barMinHeight: {
      /** 单柱 */
      single: 0.5,
      /** 堆叠 */
      stack: 0
    },
    /** 动画 */
    animation: [
      {
        /** 匹配条件 */
        condition: {
          /** 图最小高度 */
          minH: 0,
          /** 图最大高度 */
          maxH: 80
        },
        /** 动画时长 ms */
        time: 320,
        /** 缓动效果 */
        easing: 'cubicOut'
      },
      {
        /** 匹配条件 */
        condition: {
          /** 图最小高度 */
          minH: 80,
          /** 图最大高度 */
          maxH: 160
        },
        /** 动画时长 ms */
        time: 480,
        /** 缓动效果 */
        easing: 'cubicOut'
      }
    ]
  },
  /** 折线图规范 */
  line: {
    seriesColor: ['#3366FF', '#FF9500', '#CC41D9', '#14CCBD', '#199FFF', '#858585']
  },
  /** 雷达图规范 */
  dvRadar: {
    seriesColor: ['#3366FF', '#FF9500', '#CC41D9', '#14CCBD', '#199FFF', '#858585'],
    radarSysShape: 'circle',
    radarSysLine: {
      lineStyle: {
        color: 'rgba(0,0,0,0.06)'
      }
    },
    radarSysArea: {
      areaStyle: {
        color: ['rgba(255,255,255)', 'rgba(0,0,0,0.02)']
      }
    },
    radarSysName: {
      textStyle: {
        color: 'rgba(0,0,0,0.6)',
        fontSize: 10
      }
    },
    radarSysRadius: 64,
    radarLineStyle: [
      {
        width: 1
      }
    ],
    symbolSize: 4
  }
};

const haiwai = {};

export default {
  shouchao,
  haiwai
};
